import _ from 'lodash';
import moment from 'moment';

import CommunicationSimulator from './communication_simulator';
import Communicator from 'models/communicator';
import Factory from 'factories/all';
import OfferedCallPublisher from './offered_call_publisher';
import PhoneCall from 'models/phone_call';
import qconsole from 'scripts/lib/qconsole';

export default class WarmTransferCallSimulator extends CommunicationSimulator {
  constructor({ orgId, fakeTwilio, services }, database) {
    super(
      {
        attribute: 'incomingPhoneCalls',
        createItem: createWarmTransferCall,
        orgId,
        publisher: new OfferedCallPublisher(orgId, services.incomingCall, database),
        services,
      },
      database
    );
    this._fakeTwilio = fakeTwilio;
  }

  simulate(communication) {
    if (!this.incomingCallService.isCallQueueEmpty()) {
      qconsole.warn('Current agent has an active phone call');
      return;
    }
    this._fakeTwilio.simulateIncomingCall();
    super.simulate(communication);
  }

  get incomingCallService() {
    return this.services.incomingCall;
  }

  _createAssignee(communication) {
    return Factory.build('Assignee', {
      agentId: this.getTransferringAgentId(),
      routingGroupId: communication.routingGroupId,
    });
  }

  getTransferringAgentId() {
    if (this.transferringAgentId) {
      return this.transferringAgentId;
    }
    this.transferringAgentId = _.sample(
      _.reject(this.database.get().agents, agent => agent.id === this.database.get().currentAgent.id)
    ).id;
    return this.transferringAgentId;
  }
}

function createWarmTransferCall(rawPhoneCall) {
  let currentDate = new Date().toISOString();
  let currentAgentId = this.database.get().currentAgent.id;
  let transferringAgentId = this.getTransferringAgentId();
  return Factory.build('PhoneCallItem', {
    initiator: {
      type: Communicator.CUSTOMER,
      id: rawPhoneCall.customerId,
    },
    responder: {
      type: Communicator.AGENT,
      id: transferringAgentId,
    },
    content: {
      answeredAt: moment(currentDate)
        .subtract(500, 'ms')
        .toISOString(),
      customerNumber: rawPhoneCall.customerNumber,
      companyNumber: rawPhoneCall.companyNumber,
      status: PhoneCall.Status.WARM_TRANSFER,
      startedAt: currentDate,
      participants: [
        {
          participantId: rawPhoneCall.customerNumber,
          callId: rawPhoneCall.customerNumber,
          status: PhoneCall.ParticipantStatus.ON_HOLD,
          statusUpdatedAt: currentDate,
          type: PhoneCall.ParticipantType.CUSTOMER,
        },
        {
          participantId: transferringAgentId,
          callId: transferringAgentId,
          status: PhoneCall.ParticipantStatus.ACTIVE,
          statusUpdatedAt: currentDate,
          type: PhoneCall.ParticipantType.AGENT,
        },
        {
          participantId: currentAgentId,
          callId: currentAgentId,
          status: PhoneCall.ParticipantStatus.DIALING,
          statusUpdatedAt: currentDate,
          type: PhoneCall.ParticipantType.AGENT,
        },
      ],
      participantEvents: [
        {
          participantId: rawPhoneCall.customerNumber,
          participantStatus: PhoneCall.ParticipantStatus.DIALING,
          eventTime: moment(currentDate)
            .subtract(1250, 'ms')
            .toISOString(),
        },
        {
          participantId: rawPhoneCall.customerNumber,
          participantStatus: PhoneCall.ParticipantStatus.ACTIVE,
          eventTime: moment(currentDate)
            .subtract(1000, 'ms')
            .toISOString(),
        },
        {
          participantId: transferringAgentId,
          participantStatus: PhoneCall.ParticipantStatus.DIALING,
          eventTime: moment(currentDate)
            .subtract(750, 'ms')
            .toISOString(),
        },
        {
          participantId: transferringAgentId,
          participantStatus: PhoneCall.ParticipantStatus.ACTIVE,
          eventTime: moment(currentDate)
            .subtract(500, 'ms')
            .toISOString(),
        },
        {
          participantId: rawPhoneCall.customerNumber,
          participantStatus: PhoneCall.ParticipantStatus.ON_HOLD,
          eventTime: moment(currentDate)
            .subtract(250, 'ms')
            .toISOString(),
        },
        {
          participantId: currentAgentId,
          participantStatus: PhoneCall.ParticipantStatus.DIALING,
          eventTime: currentDate,
        },
      ],
    },
    timestamp: currentDate,
  });
}
